export default "__VITE_ASSET__BWC38dq___"